import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { PaginationDTO } from 'src/dto/other/pagination-dto';
import {
  RolesMappingDTO,
  TokenAuth,
  UserDTO,
  UserInsertDTO,
  UserRolesDTO,
  UsersMappingDTO,
} from 'src/dto/users/users-dto';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private apiUrlM = 'user/';
  private apiUrlS = 'users/';
  private apiUrlRoleM = 'role/';
  private apiUrlRoleS = 'roles/';

  constructor(private http: HttpClient) {}

  //#region GET
  getAllUsersByFilters(pagination: PaginationDTO): Observable<UsersMappingDTO> {
    return this.http.get<UsersMappingDTO>(
      environment.productionUrl +
        this.apiUrlS +
        '?page=' +
        pagination.page +
        '&per=' +
        pagination.per +
        '&filters=' +
        pagination.filters +
        '&sort=' +
        pagination.sort
    );
  }

  getAllUsers(): Observable<UsersMappingDTO> {
    return this.http.get<UsersMappingDTO>(
      environment.productionUrl + this.apiUrlS
    );
  }

  getAllRolesByFilters(): Observable<RolesMappingDTO> {
    return this.http.get<RolesMappingDTO>(
      environment.productionUrl + this.apiUrlRoleS
    );
  }

  getUserByCode(code: string): Observable<UserDTO> {
    return this.http.get<UserDTO>(
      environment.productionUrl + this.apiUrlM + code
    );
  }

  getLogout(): Observable<string> {
    return this.http.get<string>(
      environment.productionUrl + this.apiUrlM + 'logout'
    );
  }
  //#endregion

  //#region POST
  insertNewUser(user: UserInsertDTO): Observable<UserInsertDTO> {
    return this.http.post<UserInsertDTO>(
      environment.productionUrl + this.apiUrlS,
      user
    );
  }

  postLoginUser(userName: string, password: string): Observable<TokenAuth> {
    let body = {
      email: userName,
      password: password,
    };
    return this.http.post<TokenAuth>(
      environment.productionUrl + this.apiUrlM + 'login',
      body
    );
  }

  getLoginSSOUser(): Observable<any> {
    return this.http.get(
      environment.productionUrl + this.apiUrlM + 'sso/login',
      { responseType: 'text' }
    );
  }

  getSSOCallbackData(): Observable<TokenAuth> {
    return this.http.post<TokenAuth>(
      environment.productionUrl + this.apiUrlM + 'sso/callback',
      { responseType: 'text' }
    );
  }

  addUserInformationCollectionBook(userBody: UserDTO): Observable<UserDTO> {
    if (userBody.company?.code) {
      return this.http.post<UserDTO>(
        environment.productionUrl +
          this.apiUrlM +
          userBody.code +
          '/sc/' +
          userBody.company.code,
        userBody
      );
    } else if (userBody.store?.code) {
      return this.http.post<UserDTO>(
        environment.productionUrl +
          this.apiUrlM +
          userBody.code +
          '/sc/' +
          userBody.store.code,
        userBody
      );
    }
    return null;
  }
  //#endregion

  //#region PATCH
  updateUserByCode(code: string, user: UserRolesDTO): Observable<UserDTO> {
    return this.http.patch<UserDTO>(
      environment.productionUrl + this.apiUrlM + code,
      user
    );
  }
  postPasswordRecovery(body: any) {
    let bodyToSend = {
      name: 'User',
      email: body.email,
    };
    return this.http.post(
      environment.productionUrl + 'reset-password',
      bodyToSend,
      { responseType: 'text' }
    );
  }
  getResetOuthToken(token: string) {
    return this.http.get<any>(
      environment.productionUrl + 'reset-password?token=' + token
    );
  }
  patchResetPassword(body: any) {
    return this.http.patch(environment.productionUrl + 'reset-password/', body);
  }
  //#endregion

  //#region DELETE
  deleteUserByCode(code: string): Observable<string> {
    return this.http.delete<string>(
      environment.productionUrl + this.apiUrlM + code
    );
  }

  removeUserInformationCollectionBook(user_code: string): Observable<string> {
    return this.http.delete<string>(
      environment.productionUrl + this.apiUrlM + user_code + '/sc'
    );
  }
  //#endregion
}
